// extracted by mini-css-extract-plugin
export default {"overlay":"Cy-z","bodyOpen":"Dy-z","content":"Ey-z","header":"Fy-z","close":"Gy-z","closeNoHeading":"Hy-z"};